import { isSSR } from '@k2/core/util'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApiRequest } from '@/api'
import { type BrandKit, useBrandKitsResource } from '../resources'

export const useBrandKitStore = defineStore('brand-kit', () => {
  const { getBrandKit } = useBrandKitsResource()
  const { run, loading, failure } = useApiRequest()

  const kits = ref<Record<string, BrandKit>>({})

  const loadKit = async (organizationId: string, brandId: string) => {
    if (isSSR) return
    const kit = await run<BrandKit>(() => getBrandKit(organizationId, brandId))
    if (kit) kits.value = { ...kits.value, [brandId]: kit }
    return kit
  }

  return { kits, loading, failure, loadKit }
})
